import { SecurityCheckStatus } from 'types/common';
import { SortDirection } from 'utils/tableHelpers';

interface TeamMembership {
    id: string;
    teamId: string;
    teamName: string;
    role: IndividualType;
}

export interface Individual {
    id: string;
    fullName: string;
    address: Address;
    phone: string;
    type: IndividualType;
    email: string;
    customerId: string;
    preferredJobType?: JobType;
    vehicleType?: VehicleType;
    isInvited?: boolean;
    vehicleRegistrationNumber?: string;
    phoneCountryCode?: string;
    active?: boolean;
    registered?: boolean;
    //Note: For now, the BE restricts to only one team membership
    teamMemberships: TeamMembership[];
    referenceNumber?: string;
    profilePictureLink?: string;
    profilePictureStatus?: SecurityCheckStatus;
    readonly createdAt?: string;
    readonly lastLogin?: string;
    readonly hasHmrcToken: boolean;
}
export interface Address {
    addressLine1: string;
    addressLine2?: string | null;
    postCode: string;
    city: string;
    country: string;
}

export enum IndividualType {
    TRADER_ADMIN = 'TRADER_ADMIN',
    TRADER_USER = 'TRADER_USER',
    BROKER_ADMIN = 'BROKER_ADMIN',
    BROKER_CLERK = 'BROKER_CLERK',
    HAULIER_ADMIN = 'HAULIER_ADMIN',
    DRIVER = 'DRIVER',
    SYSTEM_ADMIN = 'SYSTEM_ADMIN',
    SUPER_ADMIN = 'SUPER_ADMIN',
    FREIGHT_FORWARDER_ADMIN = 'FREIGHT_FORWARDER_ADMIN',
    ACCOUNTS_MANAGER = 'ACCOUNTS_MANAGER',
    TEAM_MANAGER = 'TEAM_MANAGER',
    JOB_MANAGER = 'JOB_MANAGER',
    CLEARANCE_AGENT = 'CLEARANCE_AGENT',
    TENANT_OWNER = 'TENANT_OWNER',
}

export enum VehicleType {
    CAR = 'CAR',
    MINIVAN = 'MINIVAN',
    TRUCK = 'TRUCK',
    PANEL_VAN = 'PANEL_VAN',
    VAN = 'VAN',
}

export enum JobType {
    CDL_TRUCK_DRIVER = 'CDL_TRUCK_DRIVER',
    EXPRESS_DRIVER = 'EXPRESS_DRIVER',
}

export enum IndividualSortParameter {
    ID = 'ID',
    CUSTOMER = 'CUSTOMER',
    TYPE = 'TYPE',
    EMAIL = 'EMAIL',
    FULL_NAME = 'FULL_NAME',
    CREATED_AT = 'CREATED_AT',
    LAST_LOGIN = 'LAST_LOGIN',
}

type IndividualTypeLabel = {
    id: IndividualType;
    value: string;
};

export const individualTypeLabel: IndividualTypeLabel[] = [
    { id: IndividualType.TRADER_ADMIN, value: 'Trader admin' },
    { id: IndividualType.TRADER_USER, value: 'Trader user' },
    { id: IndividualType.BROKER_ADMIN, value: 'Broker admin' },
    { id: IndividualType.BROKER_CLERK, value: 'Broker clerk' },
    { id: IndividualType.HAULIER_ADMIN, value: 'Haulier admin' },
    { id: IndividualType.DRIVER, value: 'Driver' },
];

export const traderIndividualTypeLabel: IndividualTypeLabel[] = [
    { id: IndividualType.TRADER_ADMIN, value: 'Trader admin' },
    { id: IndividualType.TRADER_USER, value: 'Trader user' },
];

export const brokerIndividualTypeLabel: IndividualTypeLabel[] = [
    { id: IndividualType.BROKER_ADMIN, value: 'Broker admin' },
    { id: IndividualType.BROKER_CLERK, value: 'Broker clerk' },
];

export const driverIndividualTypeLabel: IndividualTypeLabel[] = [
    { id: IndividualType.HAULIER_ADMIN, value: 'Haulier admin' },
    { id: IndividualType.DRIVER, value: 'Driver' },
];

export const freightForwarderIndividualTypeLabels: IndividualTypeLabel[] = [
    {
        id: IndividualType.FREIGHT_FORWARDER_ADMIN,
        value: 'Freight Forwarder Admin',
    },
    {
        id: IndividualType.ACCOUNTS_MANAGER,
        value: 'Accounts Manager',
    },
    {
        id: IndividualType.TEAM_MANAGER,
        value: 'Team Manager',
    },
    {
        id: IndividualType.JOB_MANAGER,
        value: 'Job Manager',
    },
    {
        id: IndividualType.CLEARANCE_AGENT,
        value: 'Clearance Agent',
    },
];

export const activeInactiveTypeLabel = [
    {
        id: 'Active',
        value: 'Active',
    },
    { id: 'Inactive', value: 'Inactive' },
] as const;

export type GetIndividualsParams = Partial<{
    sortDirection: SortDirection;
    sortParameter: IndividualSortParameter;
    page: number;
    size: number;
    customerId: string;
    type: IndividualType[];
    active: boolean;
    query: string;
    queryBy: string[];
}>;
